
import {TaskUpdate, TaskUpdateType} from "@/models/task.update";
import {BatchSimJob} from "@/models/sim/batch.sim.job";

/**
 *
 * @class TaskBatchSim
 *
 * incremental progress reporting bulk / batch simulations
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2022
 *
 */
export class TaskBatchSim extends TaskUpdate {

  /** info to show to the user */
  public message: string;

  /** the icon to use */
  public icon:     string;

  /** the job being monitored */
  public job: BatchSimJob = null;

  /**
   * standard constructor, you have to uniquely identify the task progress stream (id)
   * and provide the type of progress update (type).
   *
   * @param id       the unique id of the task progress stream to clear (the context)
   * @param message  update text to show the user
   * @param progress estimate of progress
   * @param job      the job we are monitoring
   *
   */
  constructor(id: string, message: string, progress: number, job: BatchSimJob) {

    super(id, TaskUpdateType.Progress, progress);

    this.message  = message;
    this.icon     = '/assets/images/cloud-run-icon-32.png';
    this.job      = job;
  }

  /** subclasses that can render their own update should return non-empty HTML */
  render(): string {

    let secondLine = '';

    if (this.job) {

      secondLine = `Total: ${this.job.totals.total} Ok: ${this.job.totals.completed} Fail: ${this.job.totals.failed} Left: ${this.job.totals.remaining}`;
    }

    return `
<div class="task-file-upload-sub-panel">

  <div style="display: inline-block; width: 32px;">
    <img alt="creating model" class="tsp-icon" src="${this.icon}" width="32"></img>
  </div>

  <div style="display: inline-block; width: calc(100% - 40px); vertical-align: top; margin-top: 4px;">

    <div style="display: inline-block; ">
      <span class="tsp-label">${this.message}</span>
    </div>

    <div class="tsp-progress-border" style="margin-top: 6px; margin-bottom: 6px;">
      <div class="tsp-progress-bar" style="width: ${this.progress.toFixed(2)}%"></div>
    </div>

    <div style="display: inline-block; ">
      <span class="tsp-label">${secondLine}</span>
    </div>

  </div>

</div>
`;

  }


}
